"use client";

import React from 'react';
import { ArrowRight, ExternalLink, Calendar, Briefcase, BookOpen, Award } from 'lucide-react';
import IconButton from './IconButton';

// Pre-configured button variants for common use cases
interface BaseButtonProps {
  children: React.ReactNode;
  /**
   * Overrides the variant each pre-configured button ships with. Needed where
   * a button sits on a dark section and its default (e.g. `secondary`) has no
   * visible background there — see the jobs CTA.
   */
  variant?: 'primary' | 'secondary' | 'hero' | 'outline';
  onClick?: (e?: React.MouseEvent) => void;
  href?: string;
  target?: string;
  rel?: string;
  preserveCalendlyLink?: boolean;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  ariaLabel?: string;
}

// CTA Button with Arrow Right
export const CTAButton: React.FC<BaseButtonProps> = (props) => (
  <IconButton
    icon={ArrowRight}
    variant="primary"
    size="lg"
    iconPosition="right"
    {...props}
  />
);

// Hero CTA Button
export const HeroCTAButton: React.FC<BaseButtonProps> = (props) => (
  <IconButton
    icon={ArrowRight}
    variant="hero"
    size="lg"
    iconPosition="right"
    {...props}
  />
);

// External Link Button
export const ExternalLinkButton: React.FC<BaseButtonProps> = (props) => (
  <IconButton
    icon={ExternalLink}
    variant="secondary"
    size="lg"
    iconPosition="right"
    {...props}
  />
);

// Calendar Button
export const CalendarButton: React.FC<BaseButtonProps> = (props) => (
  <IconButton
    icon={Calendar}
    variant="hero"
    size="lg"
    iconPosition="right"
    {...props}
  />
);

// Job Application Button
export const JobApplicationButton: React.FC<BaseButtonProps> = (props) => (
  <IconButton
    icon={Briefcase}
    variant="hero"
    size="lg"
    iconPosition="right"
    {...props}
  />
);

// Blog Read More Button
export const BlogReadMoreButton: React.FC<BaseButtonProps> = (props) => (
  <IconButton
    icon={ArrowRight}
    variant="primary"
    size="md"
    iconPosition="right"
    {...props}
  />
);

// Demo Request Button
export const DemoRequestButton: React.FC<BaseButtonProps> = (props) => (
  <IconButton
    icon={ArrowRight}
    variant="hero"
    size="lg"
    iconPosition="right"
    {...props}
  />
);

// Award Button
export const AwardButton: React.FC<BaseButtonProps> = (props) => (
  <IconButton
    icon={Award}
    variant="primary"
    size="md"
    iconPosition="right"
    {...props}
  />
);

// Full Article Button
export const FullArticleButton: React.FC<BaseButtonProps> = (props) => (
  <IconButton
    icon={ExternalLink}
    variant="hero"
    size="lg"
    iconPosition="right"
    {...props}
  />
);

// ABIS Button with special VIP styling
export const ABISButton: React.FC<BaseButtonProps> = (props) => (
  <IconButton
    icon={ArrowRight}
    variant="hero"
    size="lg"
    iconPosition="right"
    className="btn-vip"
    {...props}
  />
);
